<template>
	<div>
        <div class="wrapper_checkbox">
            <div class="left_text title">Monthly</div>
            <label class="switch_checkbox_item">
                <input type="checkbox" name="" id="" v-model="monthlyYearly" />
                <div class="switch_checkbox"><span></span></div>
            </label>
            <div class="right_text title">
                Yearly
                <span class="save_up">Save more going yearly!</span>
            </div>
        </div>

        <div class="wrapper_pricing">

            <div class="fplus">
                <h3 class="title_top">
                  <inline-svg class="logo" :src="require('@/assets/img/Funnelish Plus.svg')" />
                </h3>
                <p class="desc">
	                Build funnels in our Drag'n'Drop editor without Clickfunnels.
                </p>
                <div class="row">
                    <div class="col-4" v-for="(item, index) in paymentPlans.funnelishPlus" :key="index">
                        <div class="item" :class="{ 'active' : index === 1 }">
                            <h3 class="title_top">{{ item.title }}</h3>
                            <div class="body_box">
                                <div class="price">
                                    <div class="wrap">
                                        <span class="currency">$</span>
                                        <span class="number">
                                            {{ !monthlyYearly ? item.monthly : item.yearlyPerMonth }}
                                        </span>
                                    </div>
                                    <div class="per_month">
                                        per month
                                    </div>
                                    <div class="billed_monthly">
                                        {{ !monthlyYearly ? 'Billed monthly' : 'Billed yearly'}}
                                    </div>
                                </div>

	                            <div class="layout-row">
		                            <v-button :border="index !== 1" @click="planChoose(item)">Get started</v-button>
	                            </div>

                                <div class="wrap_value">
                                    <div class="item" v-for="(wrapValueItem, index) in item.optionsList" :key="index">
                                        <div class="icon">
                                            <img :src="require('@/assets/img/billing/green_check_icon.svg')" alt="">
                                        </div>
                                        <div class="title" v-html="wrapValueItem"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


	        <div class="fapps item" >
		        <div class="fapps-box icon flex-center">
				        <img class="" :src="require('@/assets/img/billing/logo_price.svg')" alt="">
		        </div>
		        <div class="fapps-box">
			        <div class="">
				        <span class="title">Funnelish Apps </span><span class="subtitle">For Clickfunnels</span>
			        </div>
			        <p class="desc">In case you are using Clickfunnels already and not ready to fully switch to Funnelish,
				        you can use our apps and integrations to boost and automate your Clickfunnels sales funnels for as low as
				        $24/mo.
			        </p>
		        </div>

		        <div class="fapps-box price">
			        <div class="wrap">
				        <span class="currency">$</span>
				        <span class="number">
                    {{ !monthlyYearly ? paymentPlans.funnelishApps.monthly : paymentPlans.funnelishApps.yearlyPerMonth }}
                </span>
			        </div>
			        <div class="per_month">
				        per month
			        </div>
			        <div class="billed_monthly">
				        {{ !monthlyYearly ? 'Billed monthly' : 'Billed yearly'}}
			        </div>
		        </div>

		        <div class="fapps-box cta">
			        <v-button border @click="planChoose(paymentPlans.funnelishApps)">Get started</v-button>
		        </div>
	        </div>

        </div>

        <div class="banner billing-help-banner" style="margin: 0 auto; max-width: 885px;">
            <img :src="require('@/assets/img/billing/billing_bottom_banner_img.svg')" alt="" class="billing_bottom_banner_img">
            <div class="text_wrpr">
                <h2>👋 Need hands-on help?</h2>
                <p>
                    Talk to an expert and find the best plan for your business.
                </p>
            </div>
            <v-button border @click="openIntercom">Contact Us</v-button>
        </div>
	</div>
</template>

<script>
import VButton from "@/components/base/v-button";
import plans from '@/helpers/plans';

export default {
	components: {
		VButton,
    },
    data() {
        return {
            monthlyYearly: false,
            paymentPlans: plans,
        }
    },
	computed: {

	},
	methods: {
        planChoose(planValue){
        	let period = !this.monthlyYearly ? 'monthly' : 'yearly';
        	let planKey = planValue.key;
        	this.$router.push(`/settings/billing/checkout?period=${period}&plan=${planKey}`)
          // this.$emit('planChoose', { period: , plan: planValue });
          // this.$emit('changeStep', 2);
        },
		openIntercom() {
			window.Intercom("showNewMessage", "Need help selecting a plan:\n");
		},
		notifToggle: function () {
			this.$store.dispatch("notificationsOpenToggle");
		},
	},
	created() {
	}
};
</script>
<style lang="scss" scoped>
.wrapper_pricing{
	display: flex;
	flex-direction: column;
	max-width: 1170px;
	margin: auto auto 70px;

	.fplus {
		border-radius: 10px;
		border: 1px solid #4368E0;
		width: 100%;
		padding: 15px 15px;
		text-align: center;
		//max-width: 1000px;
	}
	.fapps {
		display: flex;
		flex-direction: row;
		border-radius: 10px;
		border: 1px solid $light-grey;
		margin-top: 30px;
		width: 100%;
		padding: 15px 15px;
		align-items: center;

		.fapps-box {
			display: flex;
			flex-direction: column;
			&.icon {
				margin: auto 20px;
				img {
					display: flex;
					flex-direction: column;
				}
			}
			&.price {
				min-width: 140px;
				align-items: center;
				.per_month {
					margin-bottom: 10px;
				}
			}
			&.cta {
				min-width: 200px;
				padding: 20px;
				.button {
					margin: auto;
					width: auto;
				}
			}
			.title {
				color: $darker-grey;
				font-weight: 600;
				font-size: 24px;
			}
			.subtitle {
				font-weight: 400;
				font-size: 18px;
				color: $dark-grey;
				margin-left: 8px;
			}
			.desc {
				color: $darker-grey;
				font-size: 14px;
				margin-top: 10px;
			}
		}
	}
}
.title_top {
	.logo {
		height: 26px;
		margin: 0 auto 10px;
	}
}
.right_box {
	>.desc {
		margin-bottom: 20px;
	}
}
</style>
